// 日付をYYYY-MM-DD形式にフォーマット
export function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// 今日の日付をYYYY-MM-DD形式で取得
export function getTodayISO() {
  return formatDate(new Date());
}

// 日付を表示用にフォーマット（YYYY年MM月DD日）
export function formatDateForDisplay(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
  const weekday = weekdays[date.getDay()];
  return `${year}年${month}月${day}日(${weekday})`;
}

// 2つの日付が同じかどうかを判定
export function isSameDate(date1, date2) {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

// 時間を表示用にフォーマット（HH:MM）
export function formatTime(time) {
  if (!time) return '';
  return time.substring(0, 5);
}

